import { ASSET_IMAGES } from './images';

export const SITE_IMAGE_SLOTS = {
  homeHero: {
    label: 'Homepage hero',
    description: 'Main water-purification image on the homepage.',
    defaultUrl: ASSET_IMAGES.heroWater,
    category: 'equipment'
  },
  productsBanner: {
    label: 'Products page banner',
    description: 'Background image at the top of the products page.',
    defaultUrl: ASSET_IMAGES.cookingOil,
    category: 'equipment'
  },
  servicesBanner: {
    label: 'Services page banner',
    description: 'Background image at the top of the services page.',
    defaultUrl: ASSET_IMAGES.heroWater,
    category: 'equipment'
  },
  contactBanner: {
    label: 'Contact page banner',
    description: 'Background image at the top of the contact page.',
    defaultUrl: ASSET_IMAGES.heroWater,
    category: 'equipment'
  },
  aboutBanner: {
    label: 'About page banner',
    description: 'Background image at the top of the about page.',
    defaultUrl: ASSET_IMAGES.blogKenyanMarkets,
    category: 'blog'
  },
  blogBanner: {
    label: 'Blog page banner',
    description: 'Background image at the top of the blog and insights page.',
    defaultUrl: ASSET_IMAGES.blogKenyanMarkets,
    category: 'blog'
  },
  calculatorBanner: {
    label: 'ROI calculator banner',
    description: 'Background image at the top of the ROI calculator.',
    defaultUrl: ASSET_IMAGES.blogFreshMilkOnTap,
    category: 'blog'
  },
  legalBanner: {
    label: 'Legal pages banner',
    description: 'Background image used on Privacy Policy, Terms, and Disclaimer.',
    defaultUrl: ASSET_IMAGES.heroWater,
    category: 'general'
  }
} as const;

export type SiteImageKey = keyof typeof SITE_IMAGE_SLOTS;
export type SiteImageMap = Record<SiteImageKey, string>;

export const DEFAULT_SITE_IMAGES: SiteImageMap = Object.fromEntries(
  Object.entries(SITE_IMAGE_SLOTS).map(([key, slot]) => [key, slot.defaultUrl])
) as SiteImageMap;
